import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { map, Observable } from 'rxjs';
import { DataSourceTypes } from './terminalAdministration.service';
import { UserService } from './user.service';

@Injectable({
	providedIn: 'root',
})
export class TerminalPrintService {
	constructor(
		private http: HttpClient,
		private userService: UserService,
	) {}

	print(terminalId: string, stationNumber: number, element: string, printConfiguration: string): Observable<void> {
		const url = `${environment.awsEnvUri}/mes/terminals/${terminalId}/stations/${stationNumber}/print`;
		return this.http.post<void>(url, { element, printConfiguration }, { headers: this.userService.getHeaders() });
	}

	getPrintData(terminalId: string, kind: DataSourceTypes, element: string): Observable<unknown> {
		const url = `${environment.awsEnvUri}/mes/terminals/${terminalId}/printdata?kind=${kind}&element=${encodeURIComponent(element)}`;
		return this.http
			.get<{ result: { data: unknown } }>(url, {
				headers: this.userService.getHeaders(),
			})
			.pipe(map((response) => response.result.data));
	}
}
